import { useContext } from 'react'
import { CarSearchForm } from './CarSearchForm'
import { shortInsurancesCarsContext } from '@/pages/vehicle/shortInsurances'

export const ShortInsurancesCarSearch = () => {
  const { updateFilter, filter } = useContext(shortInsurancesCarsContext)

  return (
    <CarSearchForm
      filter={filter}
      onSubmit={updateFilter}
      listType='contracted'
    />
  )
}